import React from "react";
import { Route, Routes } from "react-router-dom";
import WrapperComponent from "../../WrapperComponent";
import ProjectDetails from "./project-details/project-details";
import Projects from "./projectList/projects/projects";
import ProjectGroupList from "./projectList/project-group-list/project-group-list";
import Planner from "../planner/planner";

const ProjectsList = () => {
  return (
    <Routes>
      <Route path="/" element={<Projects />} />
      <Route path="/projectsGroupView" element={<ProjectGroupList />} />
      <Route
        path="/:id/planner"
        element={
          <WrapperComponent>
            <Planner />
          </WrapperComponent>
        }
      />
      <Route
        path="/:id/details"
        element={
          <WrapperComponent>
            <ProjectDetails />
          </WrapperComponent>
        }
      />
    </Routes>
  );
};

export default ProjectsList;
